import { useRef, useEffect } from 'react'

const useOutsideClick = (onOutsideClick) => {
	const elementRef = useRef(null)
	useEffect(() => {
		const handleOutsideClick = (e) => {
			if(typeof onOutsideClick === 'function' && !elementRef.current.contains(e.target)) {
				onOutsideClick(e)
			}
		}
		document.addEventListener('mousedown', handleOutsideClick, false)

		return () => {
			document.removeEventListener('mousedown', handleOutsideClick, false)
		}
	})
	return [elementRef]
}

export default useOutsideClick
